import React from 'react'
import serverBusyImg from '../../assets/images/server_busy.svg'
import Button from '../buttons/Button'
import { useDispatch, useSelector } from 'react-redux'
import { resetErrorState, setIsVisualizePageVisible } from '../../redux/createImageSlice'
import { useGenerateImages } from '../../services/imageService'

const ServerBusyError = () => {
    const generateImages = useGenerateImages();
    
        const { lastPayload } = useSelector((state) => state.createImage);
    
        const handleTryAgainButton = () => {
            if (lastPayload) {
                generateImages(
                    lastPayload.prompt_id,
                    lastPayload.user_prompt,
                    {
                        md5: lastPayload.font_id,
                        font_name: lastPayload.fontName,
                        family_url: lastPayload.fontFamilyUrl,
                        foundry_name: lastPayload.foundryName,
                    },
                );
            }
        }
    return (
        <div className='h-[calc(100vh-80px)] w-full'>
            <div className='h-full flexCenter flex-col gap-[48px]'>
                <img src={serverBusyImg} alt="server busy" className='h-[35%] w-[35%] xl:h-[296px] xl:w-[296px]' />
                <div className='h-[176px] max-w-[876px] text-center flexCenter flex-col gap-[24px]'>
                    <h1 className='text-[#313945] font-helveticaDisp-Bold text-[40px] font-[700] leading-[48px] tracking-[-0.02em]'>Server Busy.</h1>
                    <p className='text-[23px] text-secondary'>Sorry! Our server is currently busy. You can go back for now, try again later.</p>
                    <Button onClick={handleTryAgainButton} label='Try again' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[48px] " />
                </div>

            </div>
        </div>
    )
}

export default ServerBusyError